/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeExecutionStatusTransitionMode } from './EmployeeExecutionStatusTransitionMode';
/**
 * Conversation funnel-status transition operation.
 */
export type EmployeeExecutionStatusTransitionOperation = {
    /**
     * Stable operation discriminator.
     */
    kind: EmployeeExecutionStatusTransitionOperation.kind;
    /**
     * Workflow meaning of the transition.
     */
    mode: EmployeeExecutionStatusTransitionMode;
    /**
     * Exact target status name from the current funnel.
     */
    targetStatusName: string;
};
export namespace EmployeeExecutionStatusTransitionOperation {
    /**
     * Stable operation discriminator.
     */
    export enum kind {
        STATUS_TRANSITION = 'status-transition',
    }
}

